import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject, _templateObject2;
import { useQuery } from '@apollo/react-hooks';
import gql from 'graphql-tag';
export var userQuery = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\tquery forge_ui_userQuery($accountId: ID!) {\n\t\tuser(accountId: $accountId) {\n\t\t\tname\n\t\t\tpicture\n\t\t}\n\t}\n"])));
export var usersQuery = gql(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n\tquery forge_ui_usersQuery($accountIds: [ID!]!) {\n\t\tusers(accountIds: $accountIds) {\n\t\t\tname\n\t\t\taccountId\n\t\t\tpicture\n\t\t}\n\t}\n"])));
export var useUsers = function useUsers(accountIds, client) {
  var nonEmptyAccountIds = accountIds.filter(function (id) {
    return !(id === '');
  });
  var _useQuery = useQuery(usersQuery, {
      variables: {
        accountIds: nonEmptyAccountIds
      },
      client: client
    }),
    data = _useQuery.data;
  var users = {};
  if (data && data.users) {
    users = data.users.reduce(function (prev, user) {
      if (user.accountId) {
        prev[user.accountId] = {
          picture: user.picture,
          accountId: user.accountId,
          name: user.name
        };
      }
      return prev;
    }, {});
  }
  return users;
};
export var useUser = function useUser(accountId, client) {
  var _useQuery2 = useQuery(userQuery, {
      variables: {
        accountId: accountId
      },
      skip: !accountId,
      client: client
    }),
    data = _useQuery2.data;
  if (data && data.user) {
    var _data$user = data.user,
      picture = _data$user.picture,
      name = _data$user.name;
    return {
      name: name,
      picture: picture
    };
  }
  return {
    name: '',
    picture: ''
  };
};